import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Devices from './Devices/Devices';
import Maintenance from './Maintenance/Maintenance';
import Diagnostics from './Diagnostics/Diagnostics';

import Alert from './Alerts/Alert';
import Notification from './Notification/Notification';
import DynamicNoti from './Notification/DynamicNoti/DynamicNoti';
import Pingpage from './Maintenance/PingPage/Pingpage';
import DeviceSetting from './Setting/settings';
import { useSidebar } from './Utility/SidebaarContext';
import HomePage from './Home/HomePage';
import { useLocation } from "react-router-dom";
const App = () => {
   const location = useLocation();
   const basePath = location.pathname.split('/').slice(0, 2).join('/')
   const { isSidebarExpanded } =   useSidebar();







   if (basePath === '/') return (

    <Routes>
            <Route path="/Devices" element={<Devices/>} />
            <Route path="/" element={<HomePage/>} />
            <Route path="/maintenance-schedules" element={<Maintenance/>} />
            <Route path="/diagnostics-history" element={<Diagnostics/>} />
            <Route path="/Firmware-Update" element={<DeviceSetting/>} />
            <Route path="/alerts" element={<Alert/>} />
            <Route path="/Notification" element={<Notification/>} />
            {/* <Route path="/DeviceConfig" element={<DeviceForm/>} /> */}
            <Route path="/Notification/:id" element={<Notification/>}/>
            <Route path="/diagnostics-history/:id" element={<Pingpage/>} />
          </Routes>
   );

  return (
    
        <main className={`h-auto md:fixed  top-[4.5rem] ${isSidebarExpanded ? 'left-[15.438rem]':'left-[4.438rem]'}  bottom-0 right-0`}>
 
          <Routes>
            <Route path="/Devices" element={<Devices/>} />
            <Route path="/" element={<HomePage/>} />
            <Route path="/maintenance-schedules" element={<Maintenance/>} />
            <Route path="/diagnostics-history" element={<Diagnostics/>} />
            <Route path="/Firmware-Update" element={<DeviceSetting/>} />
            <Route path="/alerts" element={<Alert/>} />
            <Route path="/Notification" element={<Notification/>} />
            {/* <Route path="/DeviceConfig" element={<DeviceForm/>} /> */}
            <Route path="/Notification/:id" element={<Notification/>}/>
            <Route path="/diagnostics-history/:id" element={<Pingpage/>} />
          </Routes>
        </main>
    
  );
};

export default App;